<template>
  <div :class="{ 'price-container': true, app: hasAppPrice }" :aria-label="`${price} € Aktionspreis`">
    <div class="visually-hidden" aria-hidden="false">
      {{ price }} € Aktionspreis
    </div>
    <!-- <small class="package-hint">Je Pckg.</small> -->
    <div
      aria-hidden="true"
      :class="{ 'price-label': true, inline: inline, big: big, print: printpage, app: hasAppPrice }"
    >
      <span>Aktion</span>
      <div class="price-tag">
        <div class="price-tag-euro">{{ priceParts[0] | formatInt }},</div>
        <div class="price-tag-cent">{{ priceParts[1] }}</div>
      </div>
      
      
    </div>
    
    <div v-if="hasAppPrice" :class="{'app-price-label': true}" :aria-label="`${appPrice} € App-Preis`">
        <div class="price-tag" aria-hidden="true">
          <div class="price-tag-euro">{{ appPriceParts[0] | formatInt }},</div>
          <div class="price-tag-cent">{{ appPriceParts[1] }}</div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "price-label",
  props: {
    productData: {
      type: Object,
      required: false,
    },
    price: {
      type: Number,
      required: true
    },
    priceApp: {
      type: Number,
      required: false,
      default: 0
    },
    inline: Boolean,
    printpage: Boolean,
    big: Boolean
  },
  computed: {
    hasAppPrice() {
      return this.appPrice > 0;
    },
    appPrice() {
      if (this.priceApp > 0) {
        return parseFloat(this.priceApp);
      } else if (this.productData && this.productData.priceApp) {
        return parseFloat(this.productData.priceApp);
      }
      return 0;
    },
    priceParts() {
      if (this.price === 0 || this.price === null) {
        return [0, "00"];
      }
      const tempParts = this.price.toString().split(".");
      const part1 = parseInt(tempParts[0]);
      let part2 = tempParts.length > 1 ? tempParts[1].substr(0, 2) : "00";
      if (part2.length == 1) {
        part2 = part2 + "0";
      }
      const parts = [part1, part2];
      return parts;
    },
    appPriceParts() {
      if (this.appPrice === 0 || this.appPrice === null) {
        return [0, "00"];
      }
      const tempParts = this.appPrice.toString().split(".");
      const part1 = parseInt(tempParts[0]);
      let part2 = tempParts.length > 1 ? tempParts[1].substr(0, 2) : "00";
      if (part2.length == 1) {
        part2 = part2 + "0";
      }
      const parts = [part1, part2];
      return parts;
    }
  }
};
</script>

<style lang="scss">
@import "PriceLabel.scss";
</style>
